import { apiPaths } from "../RequestAPIPathFieldset"

export const allowedOrderingPaths = [
  apiPaths.docFirstPublicationDate,
  apiPaths.docLastPublicationDate,
  apiPaths.myDocUid,
  apiPaths.myDocField,
]
